<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <div class="thumb-example">
      <swiper :options="swiperOptionTop" class="gallery-top imgs" ref="swiperTop">
        <swiper-slide class="slide-1 imgsList" :controls="1" v-for="item in publicData" :key="index">
          <img :src="item.thumb" width="100%" @click="toDetails(item.id)">
        </swiper-slide>
      </swiper>
      <!-- swiper2 Thumbs -->
      <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
        <swiper-slide class="slide-1" :controls="1" v-for="item in publicData" :key="index">
          <img :src="item.thumb" alt="">
        </swiper-slide>
      </swiper>
    </div>
    <!-- 教程主区 -->
    <div class="main-content">
      <div class="course">
        <div class="courseList-filt">
          <h3 class="part-title">
            <img src="@/assets/course-cate.png" />
            名师小灶
          </h3>
        </div>
      </div>
      <div class="course-list">
        <div class="card-box">
          <!-- 最热 最火 最高 -->
          <div class="card-li" v-for="(item, i) in couresData" :key="i" @click="toDetails(item.id)">
            <div class="home-course-list">
              <div class="home-course-item">
                <img :src="item.thumb" />
              </div>
              <div class="home-course-des">
                <h3>
                  {{ item.title }}
                </h3>
                <div class="home-course-price">
                  <div class="home-course-tags">
                    <span v-if="item.discount_price == 0">会员专享</span>
                    <span v-else>名师小灶</span>
                    {{ item.study_num }} 人学习
                  </div>
                </div>
                <div class="authers">
                  <img :src="item.teacher.thumb" class="tea" />
                  <span>{{ item.teacher.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagefooter">
          <el-pagination background layout="prev, pager, next" prev-text="上一页" next-text="下一页" :total="total"
            :page-size="12" @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper"
  import "swiper/dist/css/swiper.css";
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'course',
    components: {
      Menu,
      Footer,
      swiper,
      swiperSlide
    },
    data() {
      return {
        swiperOptionTop: {
          effect: "fade",
          orderType: 0,
          spaceBetween: 10,
          pagination: 'page',
          paginationType: 'fraction',
          loop: true,
        },
        swiperOptionThumbs: {
          spaceBetween: 30,
          slidesPerView: 'auto',
          touchRatio: 0.2,
          slideToClickedSlide: true,
          loop: true,
        },
        categoryActive: 0,
        total: 0,
        currentPage: 1,
        couresData: [],
        publicData: []
      }
    },
    created() {
      this.userCourse()
      this.publicCourse()
    },
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.swiper
        const swiperThumbs = this.$refs.swiperThumbs.swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    },
    methods: {
      handleClick(e) {
        this.currentPage = 1
        this.couresData = []
        this.categoryActive = e._props.name
        this.getInfo(e._props.name)
      },
      publicCourse() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/course/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            "type": 4,
            "limit": 100,
          }
        }).then(res => {
          this.publicData = res.data.data.data
        }).catch(err => {

        })
      },
      userCourse() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/course/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            "type": 5,
            "limit": 12,
            "page": this.currentPage
          }
        }).then(res => {
          this.total = res.data.data.total
          this.couresData = res.data.data.data
        }).catch(err => {})
      },
      toDetails(id) {
        this.$router.push({
          path: "/CourseDetails",
          query: {
            id: id
          }
        })
      },
      currentChange(e) {
        this.currentPage = e
        this.userCourse()
      },
      prevClick(e) {
        this.currentPage = e
        this.userCourse()
      },
      nextClick(e) {
        this.currentPage = e
        this.userCourse()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .pagefooter {
    display: inline-block;
    width: 100%;
    text-align: center;
    margin: 30px 0;
    margin-bottom: 50px;

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #FABE00;
      border: 1px solid #FABE00;
      color: #fff;
    }


    /deep/ .el-pager li {
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #eaeaea;

      &:hover {
        color: #3dc57c;
      }
    }

    /deep/ .btn-prev {
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #eaeaea;
      padding: 0 10px;
    }

    /deep/ .btn-next {
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #eaeaea;
      padding: 0 10px;
    }

  }
</style>
<style scoped>
  .thumb-example {
    position: relative;
    height: calc(90vh);
    overflow: hidden;
  }

  .gallery-thumbs {
    box-sizing: border-box;
    padding: 10px 0;
    position: absolute;
    bottom: 0px;
    width: 100%;
    padding: 30px;
  }

  .gallery-thumbs .swiper-slide {
    width: 28vh;
    height: 15vh;
    overflow: hidden;
    opacity: 1;
    border-radius: 10px;
    position: relative;

  }

  .gallery-thumbs .swiper-slide img {
    display: block;
    width: 100% !important;
    position: relative;
    opacity: 1;
  }

  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
    border: 2px solid #FABE00;
  }

  .main-content {
    background: #F6F8FA;
    padding-bottom: 100px;
  }

  .course {
    padding: 0px;
    margin: 0px;
    width: 1200px;
    margin: 0 auto;
  }

  .course-list {
    padding-top: 30px;
  }

  .courseList-filt {
    padding: 50px 0 0px;
  }

  .part-title {
    font-size: 18px;
    color: #212b34;
    margin-bottom: 28px;
    font-weight: 700;
    text-align: left;
    line-height: 18px;
  }

  .el-form-item__label {
    text-align: center !important;
    font-weight: bold !important;
    line-height: 55px;
  }

  .part-title img {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .part-title span {
    float: right;
  }

  .card-box {
    font-size: 14px;
    color: #87959f;
    line-height: 20px;
    display: flex;
    flex-wrap: wrap;
    padding-top: 5px;
    width: 1200px;
    margin: 0 auto;
  }

  .card-box .card-li {
    width: 25%;
    margin-bottom: 25px;
    border-radius: 600px;
  }

  .home-course-list {
    width: 94%;
    margin: 10px auto 0;
  }

  .home-course-des {
    color: #000;
    width: 100%;
    background-color: white;
    text-align: left;
    padding: 15px 0 0;
    border-radius: 0 0 6px 6px;
  }

  .home-course-des h3 {
    font-size: 16px;
    max-width: 90%;
    width:90%;
    height: 40px;
    font-weight: 700;
    line-height: 20px;
    margin-left: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .authers {
    padding: 10px;
    margin-top: 16px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-top: 1px solid #F0F0F0;
  }

  .authers .tea {
    width: 27px;
    height: 27px;
    border-radius: 100px;
    margin-right: 10px;
  }

  .auther span {
    margin-left: 10px;
    font-size: 12px;
    line-height: 20px;
    color: #525a67;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .home-course-price {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin: 0 15px;
  }

  .price {
    color: #ff5900;
  }

  .home-course-tags {
    color: #b1b5b9;
    width: 100%;
  }

  .home-course-tags span {
    background: #FABE00;
    color: white;
    padding: 1px 5px;
    border-radius: 6px;
    float: right;
  }

  .home-course-item {
    width: 100%;
    background-color: #fff;
    margin: 0 auto;
    height: 180px;
  }

  .home-course-item img {
    height: 100%;
    width: 100%;
    border-radius: 6px 6px 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Course.vue